var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListen = function SvgListen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.398 21.198c.37.2.785.303 1.205.302 1.392 0 2.525-1.121 2.525-2.5h2.525c0 2.757-2.266 5-5.05 5a5.05 5.05 0 0 1-4.238-2.283l-4.866-7.44A9.15 9.15 0 0 1 4 9.25C4 4.15 8.19 0 13.34 0a9.3 9.3 0 0 1 5.554 1.847v3.485A6.83 6.83 0 0 0 13.341 2.5c-3.759 0-6.816 3.028-6.816 6.75a6.7 6.7 0 0 0 1.091 3.668l4.868 7.44c.23.352.544.64.914.84m-.28-9.29c0 2.065 1.66 3.744 3.706 3.744v-1.497c-1.226 0-2.225-1.008-2.225-2.246 0-1.239.998-2.245 2.225-2.245h.74v-.748c0-2.616-2.105-4.743-4.695-4.743-2.589 0-4.695 2.127-4.695 4.743h1.482c0-1.79 1.442-3.245 3.213-3.245 1.549 0 2.844 1.111 3.147 2.585a3.74 3.74 0 0 0-2.899 3.653",
    clipRule: "evenodd"
  })));
};
export default SvgListen;